<!-- Hero Section -->
<section class="relative py-20 bg-gradient-to-br from-primary-600 via-primary-700 to-primary-800 overflow-hidden">
  <div class="absolute inset-0 opacity-10">
    <div class="absolute inset-0" style="background-image: url('data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%23ffffff\' fill-opacity=\'0.4\'%3E%3Cpath d=\'M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E');"></div>
  </div>
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
    <div class="text-center text-white">
      <h1 class="text-4xl md:text-5xl font-bold mb-6">Contact Us</h1>
      <p class="text-xl text-white/90 max-w-3xl mx-auto">
        Have a question or want to discuss a project? We'd love to hear from you.
      </p>
    </div>
  </div>
</section>

<!-- Contact Info Cards -->
<section class="py-16 bg-white">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="grid md:grid-cols-3 gap-8 -mt-32 relative z-20">
      @for (info of contactInfo; track info.title) {
        <div class="card p-8 text-center hover:-translate-y-2 transition-all duration-300">
          <div class="w-16 h-16 bg-gradient-to-br from-primary-600 to-primary-700 rounded-full flex items-center justify-center mx-auto mb-6">
            @switch (info.icon) {
              @case ('email') {
                <svg class="w-8 h-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                </svg>
              }
              @case ('phone') {
                <svg class="w-8 h-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
                </svg>
              }
              @case ('location') {
                <svg class="w-8 h-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
                </svg>
              }
            }
          </div>
          <h3 class="text-xl font-bold text-gray-900 mb-2">{{ info.title }}</h3>
          <p class="text-primary-600 font-medium mb-1">{{ info.value }}</p>
          <p class="text-sm text-gray-500">{{ info.description }}</p>
        </div>
      }
    </div>
  </div>
</section>

<!-- Contact Form Section -->
<section class="py-20 bg-gray-50">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="grid lg:grid-cols-2 gap-12">
      <!-- Form -->
      <div class="card p-8 lg:p-12">
        <h2 class="text-2xl font-bold text-gray-900 mb-6">Send Us a Message</h2>

        @if (submitSuccess) {
          <div class="bg-green-50 border border-green-200 rounded-lg p-6 mb-6">
            <div class="flex items-center space-x-3">
              <svg class="w-6 h-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
              <span class="text-green-800 font-medium">Thank you! Your message has been sent successfully.</span>
            </div>
          </div>
        }

        <form (ngSubmit)="onSubmit()" class="space-y-6">
          <div class="grid md:grid-cols-2 gap-6">
            <div>
              <label for="name" class="block text-sm font-medium text-gray-700 mb-2">Full Name *</label>
              <input
                type="text"
                id="name"
                [(ngModel)]="formData.name"
                name="name"
                required
                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all">
            </div>
            <div>
              <label for="email" class="block text-sm font-medium text-gray-700 mb-2">Email Address *</label>
              <input
                type="email"
                id="email"
                [(ngModel)]="formData.email"
                name="email"
                required
                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all">
            </div>
          </div>

          <div class="grid md:grid-cols-2 gap-6">
            <div>
              <label for="phone" class="block text-sm font-medium text-gray-700 mb-2">Phone Number</label>
              <input
                type="tel"
                id="phone"
                [(ngModel)]="formData.phone"
                name="phone"
                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all">
            </div>
            <div>
              <label for="company" class="block text-sm font-medium text-gray-700 mb-2">Company</label>
              <input
                type="text"
                id="company"
                [(ngModel)]="formData.company"
                name="company"
                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all">
            </div>
          </div>

          <div>
            <label for="subject" class="block text-sm font-medium text-gray-700 mb-2">Subject *</label>
            <select
              id="subject"
              [(ngModel)]="formData.subject"
              name="subject"
              required
              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all">
              <option value="">Select a subject</option>
              @for (subject of subjects; track subject) {
                <option [value]="subject">{{ subject }}</option>
              }
            </select>
          </div>

          <div>
            <label for="message" class="block text-sm font-medium text-gray-700 mb-2">Message *</label>
            <textarea
              id="message"
              [(ngModel)]="formData.message"
              name="message"
              required
              rows="5"
              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all resize-none"
              placeholder="Tell us about your project or inquiry..."></textarea>
          </div>

          <!-- CAPTCHA -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">Security Check *</label>
            <div class="flex items-center space-x-4">
              <div class="bg-gray-100 px-4 py-3 rounded-lg font-mono text-lg font-semibold text-gray-700">
                {{ captchaNum1 }} + {{ captchaNum2 }} = ?
              </div>
              <input
                type="text"
                [(ngModel)]="captchaAnswer"
                name="captcha"
                required
                class="w-24 px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all"
                placeholder="Answer">
              <button type="button" (click)="generateCaptcha()" class="text-primary-600 hover:text-primary-700">
                <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
                </svg>
              </button>
            </div>
            @if (captchaError) {
              <p class="text-red-500 text-sm mt-2">Incorrect answer. Please try again.</p>
            }
          </div>

          <!-- Consent Checkbox -->
          <div class="flex items-start space-x-3">
            <input
              type="checkbox"
              id="consent"
              [(ngModel)]="consentChecked"
              name="consent"
              required
              class="mt-1 w-4 h-4 text-primary-600 border-gray-300 rounded focus:ring-primary-500">
            <label for="consent" class="text-sm text-gray-600">
              I agree to the <a routerLink="/terms" class="text-primary-600 hover:text-primary-700 underline">Terms & Conditions</a> and <a routerLink="/privacy-policy" class="text-primary-600 hover:text-primary-700 underline">Privacy Policy</a>, and I am giving my consent to receive updates through SMS/Email.
            </label>
          </div>

          <button
            type="submit"
            [disabled]="isSubmitting || !consentChecked"
            class="w-full btn-primary disabled:opacity-50 disabled:cursor-not-allowed">
            @if (isSubmitting) {
              <span class="flex items-center justify-center">
                <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Sending...
              </span>
            } @else {
              Send Message
            }
          </button>
        </form>
      </div>

      <!-- Additional Info -->
      <div class="space-y-8">
        <div>
          <h2 class="text-2xl font-bold text-gray-900 mb-6">Let's Work Together</h2>
          <p class="text-gray-600 leading-relaxed mb-6">
            Whether you have a project in mind, need technical consultation, or want to explore partnership opportunities, we're here to help. Our team is ready to discuss your needs and provide solutions tailored to your business goals.
          </p>
        </div>

        <div class="bg-gradient-to-br from-primary-50 to-primary-100 rounded-2xl p-8">
          <h3 class="text-xl font-bold text-gray-900 mb-4">What Happens Next?</h3>
          <ol class="space-y-4">
            <li class="flex items-start space-x-4">
              <span class="w-8 h-8 bg-primary-600 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">1</span>
              <div>
                <h4 class="font-semibold text-gray-900">We'll Reach Out</h4>
                <p class="text-sm text-gray-600">Our team will review your inquiry and get back to you within 24 hours.</p>
              </div>
            </li>
            <li class="flex items-start space-x-4">
              <span class="w-8 h-8 bg-primary-600 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">2</span>
              <div>
                <h4 class="font-semibold text-gray-900">Discovery Call</h4>
                <p class="text-sm text-gray-600">We'll schedule a call to understand your requirements in detail.</p>
              </div>
            </li>
            <li class="flex items-start space-x-4">
              <span class="w-8 h-8 bg-primary-600 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">3</span>
              <div>
                <h4 class="font-semibold text-gray-900">Custom Proposal</h4>
                <p class="text-sm text-gray-600">We'll provide a detailed proposal tailored to your needs.</p>
              </div>
            </li>
          </ol>
        </div>

        <div class="flex items-center space-x-4 text-gray-600">
          <svg class="w-6 h-6 text-primary-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
          </svg>
          <span class="text-sm">Your information is secure and will never be shared.</span>
        </div>
      </div>
    </div>
  </div>
</section>
